export default "__VITE_ASSET__c4e7dfdf__"